import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Legacy path — password reset is OTP-based on /forgot-password. Preserve email query if present. */
export default function ResetPasswordPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = (params.get("email") || "").trim();
  const target = email
    ? `/forgot-password?email=${encodeURIComponent(email)}`
    : "/forgot-password";
  return <Navigate to={target} replace />;
}
